// AuthContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/axios';
import { completeSync } from '../services/sync/completeDataSync';
import { useNotification } from '../contexts/NotificationContext';
import db from '../services/db';
import { encryptData, decryptData } from '../services/cryptoUtils';
import { useNavigate } from 'react-router-dom';
import { completeSyncSic } from '../services/sync/completeDataSyncSIC';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
    const { showNotification } = useNotification();
    const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [user, setUser] = useState(null);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [opcaoMenu, setOpcaoMenu] = useState(null);
    // Restaurar sessão
    useEffect(() => {
        const restoreSession = async () => {

            try {
                const storedUser = await db.currentUser.get('currentUser');
                const storedUserSic = await db.currentUserSic.get('currentUser');
                console.log('INIT REGRA RESTORE SESSION!!', storedUserSic)
                if (storedUser) {
                    const vendedor = await db.vendedorModel.get(storedUser.vendedorModelId);

                    const restoredUser = {
                        token: decryptData(storedUser.token),
                        empresa: decryptData(storedUser.empresa),
                        matriz: decryptData(storedUser.matriz),
                        vendedorModel: vendedor,
                        dataUltimaSincronizacao: storedUser.dataUltimaSincronizacao
                    };

                    setIsAuthenticated(true);
                    setUser(restoredUser);
                    // Se a empresa selecionada estiver armazenada, podemos restaurá-la
                   // setSelectedCompany(decryptData(storedUser.selectedCompany) || null);
                    localStorage.setItem('isAuthenticated', 'true');
                }
                if (storedUserSic && storedUserSic.token) {
                    console.log('---> antes:', storedUserSic)
                    const currentUserData = {
                        id: 'currentUser',
                        token: decryptData(storedUserSic.token),
                        empresa: decryptData(storedUserSic.empresa),
                        matriz: decryptData(storedUserSic.matriz),
                        usuario: decryptData(storedUserSic.usuario),
                        vendedorModel: decryptData(storedUserSic.vendedorModel), // Pode ser null
                        // Aqui assumimos que matrizFilialDisponivel já vem como array ou objeto apropriado
                        matrizFilialDisponivel: storedUserSic.matrizFilialDisponivel || null,
                        matrizUnica: await decryptData(storedUserSic.matrizUnica),
                        mobile: await decryptData(storedUserSic.mobile || null),
                        sic: await decryptData(storedUserSic.sic),
                        usuario:await decryptData(storedUserSic.usuario),
                        opcaoMenu: await decryptData(storedUserSic.opcaoMenu) || null,
                        matrizSelecionada:  await decryptData(storedUserSic.matrizSelecionada) || null

                    };
                    //await db.currentUserSic.put(currentUserData);
                    setIsAuthenticated(true);
                    setUser(currentUserData);
                    console.log(user)
                    if (currentUserData.matrizSelecionada && opcaoMenu == null) {
                        const idEmpresa = currentUserData.matrizSelecionada;
                        const idUsuario = currentUserData.matrizSelecionada;
                        const response = await api.post(
                            `/api/menu/listarMenuUsuario?idEmpresa=${idEmpresa}&idUsuario=${idUsuario}`
                        );
                        console.log('Menu do usuário:', response.data);
                        setOpcaoMenu(response.data)
                    }


                    if (storedUserSic.matrizSelecionada === '') {
                        navigate(`/selecaoMatriz`);
                    }
                    localStorage.setItem('isAuthenticated', 'true');
                    //await db.currentUserSic.put(currentUserData);
                    console.log(currentUserData)
                   // await db.currentUserSic.put(currentUserData);

                    //setSelectedCompany(currentUserData.matrizSelecionada);
                }
            } catch (error) {
                console.error('Erro ao restaurar sessão:', error);
            } finally {
                setIsLoading(false);
            }
        };

        restoreSession();
    }, [navigate]);

    // Sincronizar estado com localStorage
    useEffect(() => {
        const handleStorageChange = (event) => {
            if (event.key === 'isAuthenticated' && event.newValue === 'false') {
                setIsAuthenticated(false);
                setUser(null);
                setSelectedCompany(null);
            }
        };

        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, []);

    const login = async (credentials) => {
        try {
            const response = await api.post('/auth/login', credentials);
            const loginData = response.data;
            console.log('logindata->', loginData);
            if (loginData.sic) {
                const currentUserData = {
                    id: 'currentUser',
                    token: encryptData(loginData.token),
                    empresa: encryptData(loginData.empresa),
                    matriz: encryptData(loginData.matriz),
                    vendedorModel: encryptData(loginData.vendedorModel), // Pode ser null
                    matrizFilialDisponivel:loginData.matrizFilialDisponivel || null,
                    matrizUnica: encryptData(loginData.matrizUnica),
                    mobile: encryptData(loginData.mobile || null),
                    sic: encryptData(loginData.sic),
                    usuario: encryptData(loginData.usuario)
                };

                await db.currentUserSic.put(currentUserData);
                localStorage.setItem('isAuthenticated', 'true');
                try {
                    await completeSync(showNotification, {
                        username: loginData.usuario.nome,
                        ...loginData,
                    });
                } catch (syncError) {
                    console.log('aaa')
                    console.error('Erro na sincronização dos dados:', syncError);
                    showNotification('Sincronização parcial: dados não foram atualizados.', 'warning');
                }



                setIsAuthenticated(true);

                setUser(loginData);
                if (!currentUserData.matrizUnica) {
                    navigate(`/selecaoMatriz`)
                }
              
            } else {
                console.log(loginData)
                const vendedorData = {
                    id: loginData.vendedorModel.id,
                    nome: loginData.vendedorModel.nome,
                    status: loginData.vendedorModel.status,
                    codigoVendedor: loginData.vendedorModel.codigoVendedor,
                };
                console.log(vendedorData);
                const vendedorModelId = await db.vendedorModel.add(vendedorData);

                const currentUserData = {
                    id: 'currentUser',
                    token: encryptData(loginData.token),
                    empresa: encryptData(loginData.empresa),
                    matriz: encryptData(loginData.matriz),
                    vendedorModelId,
                    dataUltimaSincronizacao: null,
                    permissaoAlterarCliente:loginData.vendedorModel.permissaoAlterarCliente,
                    permissaoDeletarCliente:loginData.vendedorModel.permissaoDeletarCliente,
                };

                await db.currentUser.put(currentUserData);
                await db.ultimoUsuarioLogado.put({ idVendedor: loginData.vendedorModel.id });

                localStorage.setItem('isAuthenticated', 'true');
                try {
                    if(loginData.usuario){
                      
                        await completeSync(showNotification, {
                            username: loginData.usuario.nome,
                            ...loginData,
                        });
                    }else{
                        await completeSync(showNotification, {
                            username: vendedorData.nome,
                            ...loginData,
                        });
                    }
                  
                } catch (syncError) {
                    console.log('aaa')
                    console.error('Erro na sincronização dos dados:', syncError);
                    showNotification('Sincronização parcial: dados não foram atualizados.', 'warning');
                }

              

                setIsAuthenticated(true);
                setUser({
                    username: vendedorData.nome,
                    ...loginData,
                });
            }
        } catch (authError) {
            const errorMessage = authError.response?.data?.message || 'Usuário ou senha inválidos.';
            console.error('Erro de autenticação:', authError);
            showNotification(errorMessage, 'error');
            throw new Error(errorMessage);
        }
    };

    const logout = async () => {
        setIsAuthenticated(false);
        setUser(null);
        try {
            await db.currentUser.delete('currentUser');
            await db.currentUserSic.delete('currentUser');
            localStorage.setItem('isAuthenticated', 'false');
        } catch (error) {
            console.error('Erro ao limpar dados do IndexedDB:', error);
        }
    };

    // Função para selecionar a empresa e buscar o menu do usuário
    const selectCompany = async (company) => {
        console.log('EMPRESA SELECT')
        setSelectedCompany(company);

        try {
            // Atualiza o storedUserSic com a nova matriz selecionada
            const storedUserSic = await db.currentUserSic.get('currentUser');
            await db.currentUserSic.put({...storedUserSic,'matrizSelecionada': await encryptData(company.id)});
    
    
            const idEmpresa = company.id;
            const idUsuario = decryptData(storedUserSic?.usuario).id || user?.id;

            // Chamada à API usando os IDs corretos
            const response = await api.post(
                `/api/menu/listarMenuUsuario?idEmpresa=${idEmpresa}&idUsuario=${idUsuario}`
            );
            console.log('Menu do usuário:', response.data);

            setOpcaoMenu(encryptData(response.data));


            const currentUserData = {
                id: 'currentUser',
                token:await decryptData(storedUserSic.token),
                empresa:await decryptData(storedUserSic.empresa),
                matriz:await decryptData(storedUserSic.matriz),
                vendedorModel:await decryptData(storedUserSic.vendedorModel),
                matrizFilialDisponivel:storedUserSic.matrizFilialDisponivel || null,
                matrizUnica: await decryptData(storedUserSic.matrizUnica),
                mobile:await decryptData((storedUserSic.mobile) || null),
                sic:await decryptData(storedUserSic.sic),
                usuario:await decryptData(storedUserSic.usuario),  // parse para converter a string em objeto
                matrizSelecionada: company.id,
                opcaoMenu:await decryptData(response.data)
            };
            
            try {
                if(decryptData(storedUserSic?.usuario).login){
                    await completeSync(showNotification, {
                        username: decryptData(storedUserSic?.vendedor).nome ,
                        ...storedUserSic,
                    });
                }else{
                    await completeSync(showNotification, {
                        username: decryptData(storedUserSic?.usuario).login ,
                        ...storedUserSic,
                    });
                }
              
            } catch (syncError) {
                console.log('aaa')
                console.error('Erro na sincronização dos dados:', syncError);
                showNotification('Sincronização parcial: dados não foram atualizados.', 'warning');
            }

          


            //await db.currentUserSic.put(storedUserSic);
            setUser({
                ...currentUserData,
            });

        } catch (error) {
            console.error('Erro ao buscar o menu do usuário:', error);
        }
    };



    if (isLoading) {
        return <div>Carregando...</div>;
    }

    return (
        <AuthContext.Provider
            value={{
                isAuthenticated,
                user,
                selectedCompany,
                login,
                logout,
                setUser,
                selectCompany,  // função atualizada
                opcaoMenu
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}
